import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from "@mui/material";
import { deletePartnerUser } from "../../services/PartnerUserService";

interface DeletePartnerUserDialogProps {
    isOpen: boolean;
    onClose: () => void;
    partnerId: string;
    partnerUserId: string;
    userName: string;
    onDeleteSuccess: () => void;
}

const DeletePartnerUserDialog: React.FC<DeletePartnerUserDialogProps> = ({
    isOpen,
    onClose,
    partnerId,
    partnerUserId,
    userName,
    onDeleteSuccess,
}) => {
    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {
        setLoading(true);
        try {
            await deletePartnerUser(partnerId, partnerUserId);
            onDeleteSuccess();
        } catch (error) {
            console.error("Failed to delete partner user:", error);
            alert("Error: Unable to delete partner user.");
        } finally {
            setLoading(false);
            onClose(); // Ensure modal closes even if an error occurs
        }
    };

    return (
        <Dialog open={isOpen} onClose={onClose} aria-labelledby="alert-dialog-title">
            <DialogTitle id="alert-dialog-title">{`Delete ${userName}?`}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Are you sure you want to delete {userName}? This action cannot be undone.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" disabled={loading}>Cancel</Button>
                <Button onClick={handleDelete} color="error" autoFocus disabled={loading}>
                    {loading ? "Deleting..." : "Delete"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeletePartnerUserDialog;
